/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';
import { useUserId } from '../../provider';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';

import { apiConfig } from '@pages/HoldersDetailPage/config/api.config';
import { UPDATE_KYC_STATUS } from '@pages/HoldersDetailPage/api/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';
import { error } from 'console';
export interface IupdateKYCStatusPluginMethods extends IPluginMethodMap {
  getupdateKYCStatus(args?: any): Promise<any>;
}
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export class updateKYCStatusPlugin implements IAgentPlugin {
  readonly methods: IupdateKYCStatusPluginMethods;

  constructor() {
    this.methods = {
      getupdateKYCStatus: this.getupdateKYCStatus.bind(this),
    };
  }

  async getupdateKYCStatus(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.findCapsules();
    return {
      // products: this.formatProducts(this.products),
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const { userId } = useUserId();
        const res = await client
          .mutation(UPDATE_KYC_STATUS, {
            input: {
              vuid: userId,
              comment: args?.comments ?? null,
              status: args?.kyc_status === 'approve' ? 'VERIFIED' : 'REJECTED',
              type: ['ID_PROOF', 'ADDRESS_PROOF'],
            },
          })
          .toPromise();
        console.info('KYC status', res);
        if (res.error) {
          throw new Error(res.error.message);
        }
        return res;
      }
    } catch (err: any) {
      log.error('error in capsules=', err?.message);
      console.error('Error in KYC', err);
      throw err;
    }
  }

  // private formatProducts(products: any) {
  //   return products.map((product: any) => product);
  // }
}
